<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'Chemical',
      urlFragment: 'chemicals',
    };
  },
};
</script>

<style></style>
